import { render, staticRenderFns } from "./OpenEndWriting.vue?vue&type=template&id=1c97af66&scoped=true"
import script from "./OpenEndWriting.vue?vue&type=script&lang=js"
export * from "./OpenEndWriting.vue?vue&type=script&lang=js"
import style0 from "./OpenEndWriting.vue?vue&type=style&index=0&id=1c97af66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c97af66",
  null
  
)

export default component.exports